'use client'

import { useMemo } from 'react'

import { CatalogNavigationModel } from '@marketplace-web/catalog/catalog-data'
import { useCatalogContext } from '@marketplace-web/catalog/catalog-page-data'

const useGetSelectedCatalogs = (): Array<CatalogNavigationModel> => {
  const {
    state: { data, filters },
  } = useCatalogContext()
  const { catalogs } = data

  const selectedCatalogs = useMemo(() => {
    const selectedIdsSet = new Set(filters.catalogIds)

    return catalogs.filter(catalog => selectedIdsSet.has(catalog.id))
  }, [catalogs, filters.catalogIds])

  return selectedCatalogs
}

export default useGetSelectedCatalogs
